import React from "react"
import { Row, Col } from "antd";
import './style.scss'

const arrtop = [
  { img: 'https://img.alicdn.com/imgextra/i1/O1CN01eED5qz1jBAZQhI2NJ_!!6000000004509-2-tps-252-144.png', name: 'Paper submission deadline' },
  { img: 'https://img.alicdn.com/imgextra/i4/O1CN01mpapQl1xxd69SfbSL_!!6000000006510-2-tps-240-144.png', name: 'Notification to authors' },
  { img: 'https://img.alicdn.com/imgextra/i1/O1CN01LDgVQG1T9J8ZMaC5f_!!6000000002339-2-tps-240-144.png', name: 'Camera ready deadline' },
];

export default function Paper() {
  return <div className="page-paper">
    <div className="paper-title">
      Paper Submissions
    </div>
    <div className className="paper-con">
      <Row className="paper-top">
        {arrtop.map((item, index) => (
          <Col lg={8} md={12} span={24} key={index}>
            <img className="noimg" alt="" src={item.img} />
            <span dangerouslySetInnerHTML={{ __html: item.name }} />
          </Col>
        ))}
      </Row>
    </div>
  </div>
}
